import React from "react";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";
import { SUBSCRIPTION_TAB } from "./constants/accountText";

export interface PlanBadgeProps {
  plan: string;
}

const PlanBadge = ({ plan }: PlanBadgeProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.dropdown.planBadgeBg,
        borderRadius: "100px",
        padding: "4px 12px",
        alignSelf: "flex-start",
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.8px",
          textTransform: "uppercase",
          color: colors.background[900],
        }}
      >
        {plan.toUpperCase()}
      </Box>
    </Box>

    <Box
      component="p"
      sx={{
        fontFamily: "Outfit, sans-serif",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "22px",
        color: colors.neutral.white,
        margin: 0,
      }}
    >
      {/free/i.test(plan) ? SUBSCRIPTION_TAB.DESCRIPTION_FREE : SUBSCRIPTION_TAB.DESCRIPTION_PAID}
    </Box>
  </Box>
);

export default PlanBadge;
